import styled, { css } from 'styled-components';

export const accordionContainer = css`
    margin-bottom: 45px;
`;

export const BlockWrapper = styled.div`
    [class*='Blockstyle__Block-sc'] {
        padding: 24px 0;
    }
`;

export const spring = css`
    margin: 0 auto;
    max-width: 1200px;
    min-width: 300px;
    padding: 0 10px;
    @media only screen and (max-width: 1024px) {
        padding: 0 20px;
    }
    @media only screen and (max-width: 639px) {
        padding: 0 10px;
    }
`;

export const springNested = css`
    margin: 0 auto;
    max-width: 1200px;
    min-width: auto;
    padding: 0 16.66667%;
    @media only screen and (max-width: 1024px) {
        padding: 0 20px;
    }
    @media only screen and (max-width: 639px) {
        padding: 0;
    }
`;